export const socialsData = {
    linkedIn: 'https://www.linkedin.com/in/amir-basic-5b389a236/',
    github: 'https://github.com/d1xY99',
    mail: 'basic.amir99@gmail.com',
}
